import { useQuery } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';
import { adaptPayoutAccount } from 'api/escrow/adapters';
import { PayoutAccount } from 'api/escrow/types';
import { memoryQueryClient } from 'providers/TanstackQuery';

async function getPayoutAccount(): Promise<PayoutAccount | null> {
  const result = await axiosClient.query.get('/api/v1/escrow/payout-account');
  const rawAccount = result.data.payout_account;
  return rawAccount ? adaptPayoutAccount(rawAccount) : null;
}

export const getPayoutAccountQueryKey = () => ['escrow', 'payout-account'] as const;

export function useGetPayoutAccountQuery(enabled = true) {
  return useQuery(
    {
      queryKey: getPayoutAccountQueryKey(),
      queryFn: getPayoutAccount,
      enabled,
    },
    memoryQueryClient,
  );
}
